module.exports = __webpack_public_path__ + "static/media/file-requirements-ex.9c97b72a.png";